import { render, staticRenderFns } from "./ChannelOrder.vue?vue&type=template&id=44e2a3f6&"
import script from "./ChannelOrder.vue?vue&type=script&lang=js&"
export * from "./ChannelOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports